import classnames from "classnames";
import { useEffect, useState } from "react";
import { useDetermineImageClass } from "../../../util";

export enum IMAGE_ORIENTATIONS {
  LANDSCAPE,
  PORTRAIT,
}

interface IImageAssetViewerProps {
  asset: IAsset;
}

const ImageAssetViewer = ({ asset }: IImageAssetViewerProps) => {
  const [isLoading, setLoading] = useState(true);
  const imageClass = useDetermineImageClass(asset);

  useEffect(() => {
    if (!asset) {
      setLoading(false);
      return;
    }

    const image = new Image();
    image.onload = (_event) => {
      setLoading(false);
    };
    image.src = asset.media.large;
  }, [asset]);

  if (!asset) {
    return null;
  }

  if (isLoading) {
    // TODO: debug sizing of preview image dimensions expanding/contracting on on load
    // return renderPreview(asset, orientation);
    return null;
  }

  return render(asset, imageClass);
};

export function render(asset: IAsset, imageClass: string) {
  return (
    <div className="mv-asset-viewer mv-asset-viewer__container">
      <img
        className={imageClass}
        src={asset.media.large}
        alt={asset.altText ? asset.altText : ""}
      />
    </div>
  );
}

export function renderPreview(asset: IAsset, imageClass: string) {
  const classNames = classnames(
    "mv-asset-viewer__preview",
    "mv-asset-viewer__preview--blurred",
    imageClass
  );

  return (
    <div className="mv-asset-viewer mv-asset-viewer__container">
      <img
        className={classNames}
        src={asset.media.thumb}
        alt={asset.altText ? asset.altText : ""}
      />
    </div>
  );
}

export default ImageAssetViewer;
